import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Scrollbar from 'react-scrollbars-custom';

import Label from 'components/_utility/Label';

import { getConflictChoice, getPackPendingRemoval, getPendingAccessories } from 'src/redux/bike/selectors';

import AccessoryChoiceGroup from 'components/AccessoryChoiceGroup/AccessoryChoiceGroup';
import PackChoiceGroup from 'components/PackChoiceGroup/PackChoiceGroup';

import { closeAccessoryResolution, resolveAccessoryPackConflict, setConflictChoice } from 'src/redux/bike/actions';

import { Wrap, Heading, Title, Description, Actions, ConfirmButton, CancelButton } from '../ConflictingAccessories/ConflictingAccessories.styled';

const AccessoryPackConflicts = () => {
  const dispatch = useDispatch();

  const packPendingRemoval = useSelector(getPackPendingRemoval);
  const pendingAccessories = useSelector(getPendingAccessories);
  const choice = useSelector(getConflictChoice);

  const handleChoose = choiceId => dispatch(setConflictChoice(choiceId));

  return (
    <Wrap>
      <Title>
        <Label name="accessoryPackConflictsTitle" />
      </Title>

      <Description>
        <Label name="accessoryPackConflictsDescription" />
      </Description>

      <Scrollbar noDefaultStyles>
        <Heading>
          <Label name="accessoryLabel" />
        </Heading>

        <AccessoryChoiceGroup
          id="accessory"
          accessories={pendingAccessories}
          onChoose={handleChoose}
          selected={choice === 'accessory'}
        />

        <Heading>
          <Label name="packLabel" />
        </Heading>

        <PackChoiceGroup id="pack" pack={packPendingRemoval} onChoose={handleChoose} selected={choice === 'pack'} />

        <Actions>
          <ConfirmButton primary onClick={() => dispatch(resolveAccessoryPackConflict())} disabled={!choice}>
            <Label name="confirmLabel"></Label>
          </ConfirmButton>
          <CancelButton onClick={() => dispatch(closeAccessoryResolution())}>
            <Label name="cancelLabel"></Label>
          </CancelButton>
        </Actions>
      </Scrollbar>
    </Wrap>
  );
};

export default AccessoryPackConflicts;
